import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {plainToClass} from "class-transformer";
import {DialogStyle600, LargeDialogWidth, MidDialogWidth} from "@app/shared/classes/common";
import {Format} from "@app/shared/enums/format.enum";
import {CommonDataService} from "@app/shared/services/common-data.service";
import {TxnErrorCode, TxnErrorCodeRequest} from "@app/shared/txn-error-code/txn-error-code";
import {TxnErrorCodeDataService} from "@app/shared/txn-error-code/txn-error-code-data.service";

@Component({
  selector: 'app-txn-error-code',
  templateUrl: './txn-error-code.component.html',
  styleUrls: ['./txn-error-code.component.css'],
  providers: [TxnErrorCodeDataService]
})
export class TxnErrorCodeComponent implements OnInit {

  // standard format and validation
  DialogStyle600 = DialogStyle600;
  Format: typeof Format = Format;


  txnErrorCodes: TxnErrorCode[];
  showTxnErrorCodes: boolean;
  dialogWidth = LargeDialogWidth;

  private _request: TxnErrorCodeRequest;
  @Input()
  set request(value: TxnErrorCodeRequest) {
    if (value) {
      this._request = value;
      this.getTxnErrorCode(value);
    }
  }

  get request(): TxnErrorCodeRequest {
    return this._request;
  }

  @Input() managingOrgId: number;

  @Output() handler: EventEmitter<TxnErrorCode[]> = new EventEmitter();

  constructor(private commonDataService: CommonDataService, private dataService: TxnErrorCodeDataService) {
  }

  ngOnInit() {

  }

  getTxnErrorCode(request: TxnErrorCodeRequest) {
    if (request && request.txnType) {
      this.dataService.getTxnErrorCode(request.refId, request.txnType, this.managingOrgId).subscribe(res => {
        this.txnErrorCodes = plainToClass(TxnErrorCode, res);
        this.processTxnErrorCodes(request, this.txnErrorCodes);
      });
    }
  }

  processTxnErrorCodes(request: TxnErrorCodeRequest, txnErrorCode: TxnErrorCode[]) {
    if (txnErrorCode.length == 0) {
      this.dialogWidth = MidDialogWidth;
    } else {
      this.dialogWidth = LargeDialogWidth;
    }
    this.showTxnErrorCodes = request.showStatusInDialog;
    if (request.emitStatus) {
      this.handler.emit(txnErrorCode);
    }
  }

  close() {
    this.showTxnErrorCodes = false;
  }

}
